(() => {
  // Shared listeners also cover collection filtering, quick-add content and
  // theme-editor replacements without observers or per-image polling.
  if (window.reaperProductMediaInitialized) return;
  window.reaperProductMediaInitialized = true;
  const selector = '.product-card-wrapper .media--hover-effect > img + img';

  function sync(image) {
    if (!(image instanceof HTMLImageElement) || !image.matches(selector)) return;
    image.parentElement.classList.toggle('is-secondary-ready', image.complete && image.naturalWidth > 0);
  }

  // Capture image events because load/error do not bubble. Failed secondary
  // images leave the primary visible instead of exposing a broken-image icon.
  document.addEventListener('load', (event) => sync(event.target), true);
  document.addEventListener('error', (event) => sync(event.target), true);
  document.querySelectorAll(selector).forEach(sync);

  // Cached images can finish before dynamic markup joins the document. Check
  // readiness on entry too, including cards inserted by collection filters.
  document.addEventListener('pointerover', (event) => {
    const card = event.target.closest('.product-card-wrapper');
    if (card && !card.contains(event.relatedTarget)) card.querySelectorAll('.media--hover-effect > img + img').forEach(sync);
  }, { passive: true });
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll(selector).forEach(sync));
})();
